import { useState, useEffect } from 'react';
export default function usePoller(onPoll, pollInterval = 20000) {
    const [timer, setTimer] = useState(60000); // default to 60 seconds
    useEffect(() => {
        if (timer > 0) {
            const interval = setInterval(() => {
                setTimer((prevTimer) => {
                    const newTime = prevTimer - 20000;
                    if (newTime <= 0) {
                        clearInterval(interval);
                        onPoll();
                        return 0;
                    }
                    return newTime;
                });
            }, pollInterval);
            return () => clearInterval(interval);
        }
    }, [timer, onPoll]);
    const resetTimer = () => setTimer(60000);
    return { resetTimer };
}
